import { render, staticRenderFns } from "./Sjbg.vue?vue&type=template&id=480432c8&scoped=true&"
import script from "./Sjbg.vue?vue&type=script&lang=js&"
export * from "./Sjbg.vue?vue&type=script&lang=js&"
import style0 from "./Sjbg.vue?vue&type=style&index=0&id=480432c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480432c8",
  null
  
)

export default component.exports